//#Global Imports
import React from "react";
//#end Global Imports

//#Local Imports
import { CircleXCloseMark, RefreshIcon, SearchIcon } from "../../assets/Icons";
import Button from "../../components/ui/Button";
import TextField from "../../components/ui/TextField";
import Typograpy from "../../components/ui/Typography";

import RemitterIconNew from "../../assets/Icons/RemitterIconNew";
import RotateIcon from "../../assets/Icons/Rotate";
import { useNavigate } from "react-router-dom";
//#end Local Imports

const RecipientNavbar = ({
  setSearchInput,
  searchInput,
  handleRefresh,
}: {
  setSearchInput: any;
  searchInput: any;
  handleRefresh: any;
}) => {
  const navigate = useNavigate();
  return (
    <div className="p-3 z-40 bg-white/70 backdrop-blur-sm">
      <div className="flex items-center gap-3 w-full">
        {/* <RemitterIconNew /> */}
        <Typograpy tagType="div" text="Recipient" className="text-[30px] font-semibold font-ssp" />
        <div className="w-[657px] mr-20">
          <TextField
            name="searchValue"
            type="text"
            placeholder={
              searchInput ? (
                <div className="flex items-center w-full justify-between">
                  <div
                    className=" cursor-pointer"
                    onClick={() => {
                      setSearchInput("");
                    }}
                  >
                    <CircleXCloseMark />
                  </div>
                </div>
              ) : (
                <div className="flex items-center gap-2 w-full">
                  <SearchIcon fillColor="fill-grey-1550" />
                  <span>Search by Name/Number/Email</span>
                </div>
              )
            }
            value={searchInput}
            fullWidth
            inputClasses="bg-white-200 !border-none !rounded-[145px] !pt-[0rem]"
            placeholderStyle={
              searchInput
                ? "!top-[0.55rem] !left-[79%] text-grey-1550 font-normal text-sm"
                : "text-grey-1550 font-normal text-sm !right-1/4 w-[90%] !top-[0.55rem]"
            }
            onChange={(e) => {
              setSearchInput(e.target.value);
            }}
            pattern="[a-zA-Z0-9 ]{1,}"
            containerStyle="!h-10"
          />
        </div>
        <div className="flex items-center gap-8">
          <Button
            bgColor="bg-transparent"
            fontStyle={{
              fontFamily: "font-ssp",
              fontSize: "text-base",
              fontWeight: "font-semibold",
              fontColor: "text-black",
            }}
            borderStyle={{
              borderRadius: "rounded",
            }}
            className="add-remitter-button items-end space-x-4 justify-end"
            onClickHandler={handleRefresh}
          >
            {/* <RefreshIcon fillColor="blue" width={"40px"} height="40px" /> */}
            <RotateIcon />
            {/* <span className="">Refresh</span> */}
          </Button>
          <div className="">
            <Button
              bgColor="bg-[#006EFF]"
              fontStyle={{
                fontFamily: "font-Inter",
                fontSize: "text-sm",
                fontWeight: "font-semibold",
                fontColor: "text-white",
              }}
              borderStyle={{
                borderRadius: "rounded-lg",
              }}
              className="w-22 add-remitter-button p-2"
              onClickHandler={() => {
                navigate("/recipient-details");
              }}
            >
              ADD NEW RECIPIENT
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RecipientNavbar;
